import React, { useState } from 'react'

import { Input, Button, Select, ConfirmModal, EditorTransitionPrompt } from '../../../components'
import { DeleteIcon } from '../../../components/icons'
import useModel from '../../../common/useModel'
import { password, required, noSpaces } from '../../../common/validators'
import { roles } from '../../../common/roles'
import { preventSubmitHandler } from '../../../common/utils'

import S from './styled'

const selectOptions = Reflect.ownKeys(roles).filter(role => roles[role] !== roles.ROOT).map(role => ({
  id: roles[role],
  name: roles[role],
}))

const Item = ({
  item, onDelete, onSave, onCancelNew, isNew,
}) => {
  const { text, reset, model, select, resetDirty } = useModel({
    values: isNew ? {
      role: roles.USER,
    } : item,
  })

  const [showModal, setShowModal] = useState(false)

  return (
    <S.Item>
      <EditorTransitionPrompt when={model.isDirty}/>
      <S.ItemContent>
        {
          isNew ? <S.IconPlaceholder /> : (
            <S.DeleteLink onClick={
              () => setShowModal(true)
            }>
              <DeleteIcon />
            </S.DeleteLink>
          )
        }

        <form autoComplete="off" onSubmit={preventSubmitHandler}>
          <Input {...{
            name: 'values.login',
            text,
            title: 'Login',
            validate: [required, noSpaces],
            autoFocus: isNew,
            readOnly: !isNew,
            disabled: !isNew,
            autoComplete: 'off',
          }}
          />
        </form>

        <form autoComplete="off" onSubmit={preventSubmitHandler} className="passwordInput">
          <Input {...{
            name: 'values.password',
            text,
            title: isNew ? 'Password' : 'New password',
            validate: [isNew ? required : null, password].filter(Boolean),
            autoComplete: 'new-password',
          }}
          />
        </form>

        <form autoComplete="off" onSubmit={preventSubmitHandler}>
          <Select {...{
            name: 'values.role',
            select,
            title: 'Role',
            values: selectOptions,
            validate: required,
            integerValue: false,
            noEmpty: true,
          }}
          />
        </form>

      </S.ItemContent>
      <S.ItemFooter>
        { isNew && (<Button blue outlined onClick={() => onCancelNew()}>Cancel</Button>) }
        { !isNew && model.isDirty && (<Button blue outlined onClick={() => reset('values')}>Reset</Button>) }
        <Button
          blue disabled={!model.isDirty || !model.isValid}
          onClick={() => onSave(model.values).then(resetDirty)}>
          {isNew ? 'Add' : 'Save'}
        </Button>
      </S.ItemFooter>
      <ConfirmModal
        isOpened={showModal}
        onClose={() => setShowModal(null)}
        onConfirm={() => {
          setShowModal(null)
          onDelete(item.userId, item)
        }}
        redConfirm
      >
        Are you sure you want to delete this user?
      </ConfirmModal>
    </S.Item>
  )
}

export default Item
